/*
 * Project: bellcloud
 * File: packages/i18n/i18n.ts
 * Author: SWAN
 * Description: i18n 초기화 함수
 */

import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

type InitI18nOptions = {
  debug?: boolean;
};

export function initI18n({ debug = false }: InitI18nOptions = {}) {
  if (i18n.isInitialized) {
    return i18n;
  }

  try {
    i18n
      .use(Backend)
      .use(LanguageDetector)
      .use(initReactI18next)
      .init({
        supportedLngs: ['en', 'ko', 'es'],
        fallbackLng: 'en',
        debug,
        ns: [
          'common',
          'config',
          'auth',
          'site',
          'company',
          'datalog',
          'monitoring',
          'device',
          'guide',
        ],
        defaultNS: 'common',
        detection: {
          order: ['localStorage', 'navigator'],
          caches: ['localStorage'],
          lookupLocalStorage: 'i18nextLng',
        },
        interpolation: {
          escapeValue: false,
        },
        backend: {
          // ✅ apps/frontend/public/locales 사용
          loadPath: '/locales/{{lng}}/{{ns}}.json',
        },
        react: {
          useSuspense: true,
          bindI18n: 'languageChanged loaded',
          bindI18nStore: 'added removed',
        },
      });
  } catch (error) {
    console.warn('i18n initialization failed:', error);
  }

  return i18n;
}
